import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { equals, string_type, record_type, int32_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { UrlKind, ValidatedUrlModule_create, UrlKind$reflection } from "../HttpV2.js";
import { LoadState$2, LoadState$2$reflection } from "../Global.js";
import * as react from "react";
import { dotsLoading } from "../ViewUtils.js";
import { error } from "../Components/Message/Message.js";
import { stackClasses } from "../Utils.js";
import { ofArray } from "../fable_modules/fable-library.3.7.20/List.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { FunctionComponent_Of_Z5A158BBF } from "../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import "../../src/DevTools/TestData.scss";


export class DifferentContractStates extends Record {
    constructor(ClientNr, InvoiceeNr, Count) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.InvoiceeNr = (InvoiceeNr | 0);
        this.Count = (Count | 0);
    }
}

export function DifferentContractStates$reflection() {
    return record_type("DevTools.TestData.DifferentContractStates", [], DifferentContractStates, () => [["ClientNr", int32_type], ["InvoiceeNr", int32_type], ["Count", int32_type]]);
}

export class RenderBlockProps extends Record {
    constructor(Text$, UrlKind) {
        super();
        this.Text = Text$;
        this.UrlKind = UrlKind;
    }
}

export function RenderBlockProps$reflection() {
    return record_type("DevTools.TestData.RenderBlockProps", [], RenderBlockProps, () => [["Text", string_type], ["UrlKind", UrlKind$reflection()]]);
}

export class RenderBlockState extends Record {
    constructor(Data) {
        super();
        this.Data = Data;
    }
}

export function RenderBlockState$reflection() {
    return record_type("DevTools.TestData.RenderBlockState", [], RenderBlockState, () => [["Data", LoadState$2$reflection(string_type, string_type)]]);
}

function renderBlock$0027(props) {
    let children_7;
    const state = react.useState(new RenderBlockState(new LoadState$2(0)));
    let resultHtml;
    const matchValue_3 = (state[0]).Data;
    switch (matchValue_3.tag) {
        case 1: {
            resultHtml = dotsLoading;
            break;
        }
        case 3: {
            resultHtml = error(matchValue_3.fields[0].split(""));
            break;
        }
        case 2: {
            resultHtml = react.createElement("div", {}, matchValue_3.fields[0]);
            break;
        }
        default: {
            resultHtml = react.createElement(react.Fragment, {});
        }
    }
    const flexClasses = stackClasses(ofArray(["d-flex", "align-items-center", "mb-2"]));
    const children_11 = [(children_7 = [react.createElement("span", {
        className: "mr-2",
    }, props.Text), react.createElement("button", {
        onClick: (_arg_2) => {
            startImmediate(singleton.Delay(() => {
                let matchValue, parseFn, arg;
                state[1]((x) => (new RenderBlockState(new LoadState$2(1))));
                return singleton.Bind((matchValue = ValidatedUrlModule_create(props.UrlKind), (matchValue.tag === 1) ? singleton.Delay(() => singleton.Return(new FSharpResult$2(1, matchValue.fields[0]))) : ((parseFn = ((arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1) => {
                    const str = arg_1;
                    return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg, Http_get_ExtraCoders().Value)), str);
                })), singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
                    let response_1;
                    return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
                }))))), (_arg_1) => {
                    const data = _arg_1;
                    const updatedData = (data.tag === 1) ? (new LoadState$2(3, data.fields[0])) : (new LoadState$2(2, data.fields[0]));
                    state[1]((x_2) => (new RenderBlockState(updatedData)));
                    return singleton.Zero();
                });
            }));
        },
    }, "GET")], react.createElement("div", {
        className: flexClasses,
    }, ...children_7)), react.createElement("div", {
        className: "bg-white p-2",
    }, resultHtml)];
    return react.createElement("div", {}, ...children_11);
}

export function renderBlock() {
    return FunctionComponent_Of_Z5A158BBF(renderBlock$0027, void 0, uncurry(2, void 0), void 0, "renderBlock", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\DevTools\\TestData.fs", 63);
}

export const render = (() => {
    let children;
    const children_2 = [(children = [renderBlock()(new RenderBlockProps("Get some invoicees with at least two contracts where at least one is Cancelled and one is Active.", new UrlKind(0, "/TestData/DifferentContractStates/")))], react.createElement("div", {}, ...children))];
    return react.createElement("div", {
        className: "test-data",
    }, ...children_2);
})();

